import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import Breadcrumb from '../components/Breadcrumb';
import EmployeeListLayer from '../components/EmployeeListLayer';

const EmployeeListPage = () => {
    return (
        <MasterLayout>
            <Breadcrumb title='Employee List' />
            <EmployeeListLayer />
        </MasterLayout>
    );
};

export default EmployeeListPage;

